import { createContext, defaultValue, useContext } from 'react';

const ContextManagerContext = createContext(defaultValue);

export const ContextManagerProvider = ContextManagerContext.Provider;
export const useContextManager = () => useContext(ContextManagerContext);
